import { RefreshCw, X } from 'lucide-react';
import { useAuth } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { dismissLoginGateUnavailable, useLoginGateUnavailable } from './use-login-gate';

import { Button } from '@/components/ui';

/**
 * W.4.116 (#2689): shown when a gated control (PDF to Excel, PDF to Markdown,
 * …) was pressed and the account script did not load. Before this the button
 * did nothing. Mounted once in `main.tsx`; `useLoginGate` decides when.
 */
export function LoginGateUnavailableNotice() {
  const shown = useLoginGateUnavailable();
  const { isLoaded } = useAuth();
  // This notice remains mounted across routes; the gate that requested it may
  // already have unmounted by the time the account script recovers.
  useEffect(() => {
    if (isLoaded) dismissLoginGateUnavailable();
  }, [isLoaded]);
  if (!shown || isLoaded) return null;
  const host = typeof window !== 'undefined' ? window.location.hostname : 'this site';
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex justify-center p-4">
      <div
        role="alert"
        className="pointer-events-auto flex w-full max-w-xl items-start gap-3 rounded-lg border border-border bg-popover p-4 text-popover-foreground shadow-float"
      >
        <p className="min-w-0 flex-1 text-sm leading-6">
          Sign-in could not load. Turn off your content blocker for {host}, or reload the page.
        </p>
        <Button size="sm" onClick={() => window.location.reload()} className="shrink-0 gap-1.5">
          <RefreshCw className="h-4 w-4" aria-hidden /> Reload
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={dismissLoginGateUnavailable}
          aria-label="Close"
          className="h-8 w-8 shrink-0"
        >
          <X className="h-4 w-4" aria-hidden />
        </Button>
      </div>
    </div>
  );
}
